import React from "react";
import { ReactComponent as SideTableSvg } from "../svg/side-table.svg";

export default function SideTableIcon({ size = 64, color = "#32363F", ...props }) {
  return <SideTableSvg width={size} height={size} style={{ color }} {...props} />;
}
